export enum BannerName {
  Top = 'top',
  TopDesktop = 'topDesktop',
  Card = 'card',
  Bottom = 'bottom',
}
